import type { AxiosResponse } from "axios";

/**
 * Сохраняет blob-ответ (например DOCX) как файл: имя берётся из
 * `Content-Disposition`, иначе `fallbackName`.
 */
export function saveBlobResponse(
  resp: AxiosResponse<Blob>,
  fallbackName: string,
): void {
  const cd = String(resp.headers["content-disposition"] || "");
  const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)/i.exec(cd);
  const filename = m?.[1] ? decodeURIComponent(m[1]) : fallbackName;
  const url = URL.createObjectURL(resp.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
